export function isBlank(value) {
  if (value == null) return true;
  if (typeof value === 'number') return Number.isNaN(value);
  if (Array.isArray(value)) return value.filter((item) => !isBlank(item)).length === 0;
  return String(value).trim() === '';
}

export function isPositiveAmount(value) {
  const n = parseFloat(String(value ?? '').replace(/,/g, '').trim());
  return Number.isFinite(n) && n > 0;
}

export function isFilledNumber(value) {
  const raw = String(value ?? '').replace(/,/g, '').trim();
  if (raw === '') return false;
  return Number.isFinite(Number(raw));
}

export function missingRequiredMessage(fields) {
  const missing = (fields || []).filter((field) => {
    if (field.when === false) return false;
    if (typeof field.check === 'function') return !field.check(field.value);
    return isBlank(field.value);
  });
  if (missing.length === 0) return '';
  if (missing.length === 1) return `${missing[0].label} is required`;
  return `Please fill in: ${missing.map((field) => field.label).join(', ')}`;
}
